export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4650.72c90cb7.jpg";